import { Accordion, AccordionSummary, Typography, AccordionDetails, Divider, Stack, TextField, IconButton } from "@mui/material"
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Check from '@mui/icons-material/Check'
import { observer } from "mobx-react-lite"
import { useMainStore } from "./store"
import React from "react"

const OtherProps = observer(() => {

  const store = useMainStore()
  const titles = {
    countModules: "Кол-во модулей"
  }

  const props = (key: string, index?: number) => ({
    label: (titles as any)[key] || (typeof index === "number" && (store.scheme.definedEntries as any)[index][key]),
    value: (store.values as any)[key] || "",
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => store.setValue(key as any, e.target.value)
  })

  return (
    <Accordion defaultExpanded={true} elevation={0} square disableGutters sx={{ borderBottom: 1, borderColor: "divider" }}>
      <AccordionSummary sx={{ bgcolor: "grey.100" }} expandIcon={<ExpandMoreIcon />}>
        <Typography>Настройки проекта</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Stack direction="row" spacing={2}>
          <Stack spacing={1} direction="row" alignItems="center" alignSelf="flex-start">
            <TextField 
              {...props("countModules")} 
              size="small" 
              variant="standard" 
              type="number"
              onKeyDown={e => e.code === "Enter" && store.applyCountModules()}
            />
            <IconButton 
              disabled={typeof store.values.countModules === "number"}
              sx={{ transform: `translateY(4px)` }} 
              color="success" 
              onClick={() => store.applyCountModules()}
            >
              <Check/>
            </IconButton>
          </Stack>
          { store.scheme.definedEntries.map((keyGroup, index) => (
            <React.Fragment key={index}>
              <Divider orientation="vertical" flexItem />
              <Stack spacing={2} sx={{ width: keyGroup._size }}>
                { Object.keys(keyGroup).map(key => key.startsWith("_")? null: (
                  <TextField key={key} {...props(key, index)} size="small" variant="standard" />
                ))}
              </Stack>
            </React.Fragment>
          ))}
        </Stack>
      </AccordionDetails>
    </Accordion>
  )

})

export default OtherProps